import React, { useState, useCallback } from 'react';
import { MDBInput, MDBBtn, MDBIcon } from 'mdb-react-ui-kit';
import { useTranslation } from 'react-i18next';

const TagInput = ({ tags = [], onChange, placeholder }) => {
  const { t } = useTranslation();
  const [draft, setDraft] = useState('');

  const commit = useCallback((raw) => {
    const value = (raw ?? draft).trim();
    if (!value) return;
    if (tags.includes(value)) {
      setDraft('');
      return;
    }
    onChange([...tags, value]);
    setDraft('');
  }, [draft, tags, onChange]);

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      commit();
    } else if (e.key === 'Backspace' && draft === '' && tags.length > 0) {
      onChange(tags.slice(0, -1));
    }
  }, [commit, draft, tags, onChange]);

  const removeTag = useCallback((tag) => {
    onChange(tags.filter(t => t !== tag));
  }, [tags, onChange]);

  return (
    <div className="tag-input">
      <div className="d-flex flex-wrap gap-1 mb-2">
        {tags.map(tag => (
          <span key={tag} className="badge bg-primary d-inline-flex align-items-center">
            {tag}
            <MDBIcon
              fas
              icon="times"
              className="ms-2"
              style={{ cursor: 'pointer' }}
              onClick={() => removeTag(tag)}
            />
          </span>
        ))}
      </div>
      <div className="d-flex gap-2">
        <MDBInput
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={handleKeyDown}
          label={placeholder || t('Add tag (Enter or comma)')}
          size="sm"
        />
        <MDBBtn type="button" size="sm" onClick={() => commit()} disabled={!draft.trim()}>
          {t('Add')}
        </MDBBtn>
      </div>
    </div>
  );
};

export default TagInput;
